

// uniform vec3 uBaseColor;
// uniform sampler2D uEnvMap;
// uniform vec3 uCameraPosition;
// uniform float uHazeStart;
// uniform float uHazeEnd;
// uniform float uHazeIntensity;

// void main() {
//     // Direction from camera to fragment
//     vec3 viewDir = normalize(vWorldPosition - uCameraPosition);

//     // Horizon direction (force horizontal)
//     vec3 horizonDir = normalize(vec3(viewDir.x, 0.0, viewDir.z));

//     // Convert to equirectangular UV
//     float u = atan(horizonDir.z, horizonDir.x) / (2.0 * 3.14159265) + 0.5;
//     float v = asin(clamp(horizonDir.y, -1.0, 1.0)) / 3.14159265 + 0.5;

//     // Sample HDRI
//     vec3 horizonColor = texture2D(uEnvMap, vec2(u, v)).rgb;

//     // Distance-based haze
//     float hazeFactor = smoothstep(uHazeStart, uHazeEnd, vDistanceFromCamera) * uHazeIntensity;

//     // Final color
//     vec3 finalColor = mix(uBaseColor, horizonColor, hazeFactor);

//     gl_FragColor = vec4(finalColor, 1.0);
// }

// uniform vec3 uBaseColor;
// uniform sampler2D uEnvMap;
// uniform vec3 uCameraPosition;
// uniform float uHazeStart;
// uniform float uHazeEnd;
// uniform float uHazeIntensity;

// void main() {
//     // Direction from camera to fragment
//     vec3 viewDir = normalize(vWorldPosition - uCameraPosition);

//     // Force horizontal direction for horizon
//     vec3 horizonDir = normalize(vec3(viewDir.x, 0.0, viewDir.z));

//     // Convert to equirectangular UV
//     float u = atan(horizonDir.z, horizonDir.x) / (2.0 * 3.14159265) + 0.5;
//     float v = asin(clamp(horizonDir.y, -1.0, 1.0)) / 3.14159265 + 0.5;

//     // Apply optional vertical offset to align HDRI horizon
//     v += 0.05;
//     v = clamp(v, 0.0, 1.0);

//     // Sample HDRI for horizon color
//     vec3 horizonColor = texture2D(uEnvMap, vec2(u, v)).rgb;
//     horizonColor = pow(horizonColor, vec3(1.0/2.2));

//     // Distance-based haze factor
//     float hazeFactor = smoothstep(uHazeStart, uHazeEnd, vDistanceFromCamera) * uHazeIntensity;

//     // Blend base color (black) with horizon color
//     vec3 finalColor = mix(uBaseColor, horizonColor, hazeFactor);

//     gl_FragColor = vec4(finalColor, 1.0);
// }

varying vec3 vWorldPosition;
varying float vDistanceFromCamera;

uniform vec3 uBaseColor;
uniform sampler2D uEnvMap;          // Equirectangular HDR texture
uniform vec3 uCameraPosition;
uniform float uHazeStart;
uniform float uHazeEnd;
uniform float uHazeIntensity;

#define PI 3.14159265359

void main() {
    // 1️⃣ Direction from camera to fragment
    vec3 viewDir = normalize(vWorldPosition - uCameraPosition);

    // 2️⃣ Horizon direction (force horizontal)
    vec3 horizonDir = normalize(vec3(viewDir.x, 0.0, viewDir.z));

    // 3️⃣ Convert direction to equirectangular UV coordinates
    float u = atan(horizonDir.z, horizonDir.x) / (2.0 * PI) + 0.5;
    float v = 0.5; // Sample at horizon (middle of texture vertically)

    // 4️⃣ Sample HDR texture
    vec3 horizonColor = texture2D(uEnvMap, vec2(u, v)).rgb;

    // 5️⃣ Distance-based haze factor
    float hazeFactor = smoothstep(uHazeStart, uHazeEnd, vDistanceFromCamera) * uHazeIntensity;

    // 6️⃣ Blend base color with horizon color
    vec3 finalColor = mix(uBaseColor, horizonColor, hazeFactor);

    gl_FragColor = vec4(finalColor, 1.0);
}